module.exports = __webpack_public_path__ + "static/media/iconTipo.c604250f.svg";